import React, { createContext, useState } from 'react';

export const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
    const [userData, setUserdata] = useState({});
    const [userName, setUserName] = useState(null);
     const [userId, setUserId] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isPremium, setIsPremium] = useState(false);

    return (
        <LoginContext.Provider
            value={{
                userName,
                setUserName,
                userId,
                setUserId,
                userData,
                setUserdata,
                isLoggedIn,
                setIsLoggedIn,
                isPremium,
                setIsPremium,
            }}  >
                
            {children}
        </LoginContext.Provider>
    );
};
